import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TanstackTableLocale } from '@thingslog/ui-components';

/**
 * Builds the `TanstackTable` UI locale from the app's i18n (the single source of
 * truth for translations). Feed the result to a single `TanstackTableLocaleProvider`
 * near the app root so every table is localized without per-page wiring.
 */
export function useTableLocale(): TanstackTableLocale {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      searchPlaceholder: t('table_search_placeholder'),
      columnsButton: t('table_columns'),
      toggleAll: t('table_toggle_all'),
      filter: t('table_filter'),
      clearFilter: t('table_clear_filter'),
      pinLeft: t('table_pin_left'),
      pinRight: t('table_pin_right'),
      unpin: t('table_unpin'),
      groupByColumn: t('table_group_by_column'),
      ungroup: t('table_ungroup'),
      filterAll: t('table_filter_all'),
      noValues: t('table_no_values'),
      min: t('table_min'),
      max: t('table_max'),
      equals: t('table_equals'),
      from: t('table_from'),
      to: t('table_to'),
      yes: t('table_yes'),
      no: t('table_no'),
      filterPlaceholder: t('table_filter_placeholder'),
      densityCompact: t('table_density_compact'),
      densityStandard: t('table_density_standard'),
      densityComfortable: t('table_density_comfortable'),
      autoPageSizeLabel: t('table_auto_page_size'),
    }),
    [t]
  );
}
